import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { createReport, readReportPrompts } from '@api/reports';
import { Breadcrumbs } from '@utilities';

import Builder from '../../components/Builder';
import Column from '../../layouts/Column';

const CreateReport = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { report: documentId } = useParams();

  return (
    <Column>
      <Breadcrumbs />
      <Builder
        create={createReport}
        documentId={documentId}
        onSubmit={({ reportId }) => navigate(`/dashboard/report/${reportId}`)}
        read={() => readReportPrompts({ documentId, search, transform: false })}
        type="Report"
      />
    </Column>
  );
};

export default CreateReport;
